<span class="notification-badge" [ngClass]="[badgeColor, position]" >{{ notificationQuantity }}</span>